import { ShieldCheck, History, Flag, NotebookPen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Maps the `icon` string in sites.json to a lucide-react component.
 *
 * sites.json holds plain strings so it can drive both the build and CI.
 * When you add a site, register its icon here (or CI will fail).
 */
export const iconRegistry: Record<string, LucideIcon> = {
  ShieldCheck,
  History,
  Flag,
  NotebookPen,
};